<template>
  <div>
    <div class="row page-title-header">
      <div class="col-12">
       <BreadCrumb :extra-items="[{
          text: customer.name
        }]" />
      </div>
    </div>

    <div class="d-flex">
      <b-card class="mr-3 w-100 p-3">
        <b-overlay :show="showLoading" rounded="sm">
          <div class="row align-items-start">
            <!-- Top -->
             <div class="col-12 col-xl-6">
              <CustomerCard
                :customer="customer"
                :show-unbind-button="customers.length > 0"
                :show-delete-button="showDeleteButton"
                :show-soft-delete-button="showSoftDeleteButton"
                @trigger-fetch-customer="getCustomer"
                @trigger-init-data="loadInitialData"
              />
              <b-card class="shadow-none rounded rounded-3 flex-fill mb-3">
                <div
                  class="
                    wrapper
                    d-flex
                    align-items-center
                    font-weight-medium
                    text-muted
                  "
                >
                  <i :id="`icon-account-level-card-details-${customer.id}`" class="mdi mdi-crown mr-2" ></i>
                  <b-tooltip :target="`icon-account-level-card-details-${customer.id}`" placement="left">會員等級</b-tooltip>
                  <p class="mb-0 text-muted text-sm" v-if="customer.loyalty">
                    {{ customer.loyalty.level_name }}
                  </p>
                </div>
                <div
                  class="
                    wrapper
                    d-flex
                    align-items-center
                    font-weight-medium
                    text-muted
                  "
                >
                  <i :id="`icon-account-level-card-expired-${customer.id}`" class="mdi mdi-calendar-range mr-2" ></i>
                  <b-tooltip :target="`icon-account-level-card-expired-${customer.id}`" placement="left">到期日</b-tooltip>
                  <p class="mb-0 text-muted text-sm" v-if="customer.loyalty">
                    <template v-if="customer.loyalty.level_start_at && customer.loyalty.level_end_at">
                      {{ customer.loyalty.level_start_at }} ～ {{ customer.loyalty.level_end_at }}
                    </template>
                    <template v-else-if="customer.loyalty.level_start_at && !customer.loyalty.level_end_at">
                      {{ customer.loyalty.level_start_at }} ～ 無期限
                    </template>
                    <template v-else-if="!customer.loyalty.level_start_at && customer.loyalty.level_end_at">
                      ～ {{ customer.loyalty.level_end_at }}
                    </template>
                  </p>
                </div>
              </b-card>
            </div>


            <div class="flex-fill col-12 col-xl-6">
              <div class="d-flex flex-row align-items-center" v-for="(i,idx) in customers" :key="i.id">
                <template v-if="showCustomers || idx==0">
                  <i class="mdi mdi-link-variant mdi-rotate-45 mr-2 h3 text-secondary"></i>
                  <CustomerCard
                    :customer="i"
                    :show-unbind-button="customers.length > 0"
                    :show-underline="true"
                    @trigger-fetch-customer="getCustomer"
                    @trigger-init-data="loadInitialData"
                  />
                </template>
              </div>
              <b-button v-if="customers.length>1" class="w-100 d-flex justify-content-between" variant="secondary" @click="showCustomers=!showCustomers">
                {{ showCustomers?'隱藏內容':'展開更多' }}
                <i class="mdi" :class="`mdi-chevron-double-${showCustomers?'up':'down'}`"></i></b-button>
            </div>
          </div>

          <!-- Bottom -->
          <div class="mt-5">
            <b-tabs v-model="activeTabIndex" @input="handleTab">
              <b-tab
                v-for="(tab, index) in tabs"
                v-bind:key="index"
                :title="tab.title"
              ></b-tab>
            </b-tabs>

            <div v-if="activeTabHash === '#tag'">
              <div class="p-3">
                <div v-if="!isEditTags">
                  <b-badge
                    pill
                    variant="dark"
                    v-for="tag in orderedTags"
                    :key="tag"
                    class="mr-1"
                    >{{ tag }}</b-badge
                  >
                </div>
                <b-form-tags
                  v-else
                  input-id="tags"
                  v-model="tags"
                  placeholder="輸入標籤"
                  size="lg"
                  tag-variant="dark"
                  remove-on-delete
                  separator=" ,;"
                  addButtonText="新增"
                ></b-form-tags>
                <div
                  v-if="checkPermission([consts.CUSTOMER_LIST_TAG_EDIT])"
                  class="mt-3 text-center"
                >
                  <b-button
                    v-if="!isEditTags"
                    class="flex-shrink-0"
                    variant="inverse-warning"
                    @click="isEditTags = true"
                  >
                    編輯標籤
                  </b-button>

                  <template v-else>
                    <b-button
                      class="mr-2"
                      variant="inverse-info"
                      @click="handleCancelTags"
                    >
                      取消
                    </b-button>
                    <b-button variant="inverse-primary" @click="handleSaveTags">
                      儲存
                    </b-button>
                  </template>
                </div>
              </div>
            </div>

            <div v-if="activeTabHash === '#basic'">
              <div class="p-3">
                <div>顯示名稱：{{ customer.name }}</div>
                <div>手機：{{ customer.mobile_phone }}</div>
                <div>Email：{{ customer.email }}</div>
                <div>生日：{{ customer.birthday }}</div>
                <div>性別：{{ customer.sexual }}</div>
                <div>好友：{{ customer.is_friend ? "是" : "否" }}</div>
                <div>識別編號：{{ customer.outer_code }}</div>
                <div>建立時間：{{ customer.created_at }}</div>
                <div>加入時間：{{ customer.join_datetime }}</div>
                <div v-if="customer.leave_datetime">
                  離開時間：{{ customer.leave_datetime }}
                </div>
                <div>更新時間：{{ customer.updated_at }}</div>
                <div>
                  手機是否驗證：{{ customer.phone_verified ? "是" : "否" }}
                </div>
                <div>手機驗證時間：{{ customer.phone_verified_at }}</div>
                <div>
                  Email 是否驗證：{{ customer.email_verified ? "是" : "否" }}
                </div>
                <div>Email 驗證時間：{{ customer.email_verified_at }}</div>
                <div>註冊時間：{{ customer.registered_at }}</div>
                <div>條款接受時間：{{ customer.accept_term_at }}</div>
              </div>
            </div>

            <div v-if="activeTabHash === '#detail'">
              <div class="p-3">
                <div v-for="(field, index) in fields" :key="'field' + index">
                  {{ field.title }} :
                  <b-button
                    v-if="(customer.profiles[field.matched_key] || '').length > 30"
                    v-b-modal.modal-full-view
                    class="flex-shrink-0 mr-2"
                    variant=""
                    @click="logForFullView = customer.profiles[field.matched_key] || '', logTitle = field.title"
                  >
                    <span class="mdi mdi-arrow-expand-all"></span>
                  </b-button>
                  {{ (customer.profiles[field.matched_key] || '') | hiddenString(30) }}
                </div>
              </div>
            </div>

            <div v-if="activeTabHash === '#staff-bind-list'">
              <customer-staff-list />
            </div>

            <div v-if="activeTabHash === '#list-by-user-id'">
              <CustomerListByUserID />
            </div>

            <div v-if="activeTabHash === '#list-point-logs'" class="p-3">
              <PointLog
                :showFilter="false"
                :excludeFields="['customer_name', 'actions']"
                :upperCustomerId="$route.params.customerID"
                :upperMerchantId="customer.merchant.id"
              />
            </div>
            <div v-if="activeTabHash === '#list-redeem-logs'" class="p-3">
              <RedeemLog
                :showFilter="false"
                :includeFields="[
                  'created_at',
                  'gift_name',
                  'gift_data',
                  'batch_total_points',
                ]"
                :upperMerchantId="customer.merchant.id"
                :upperCustomerId="$route.params.customerID"
              />
            </div>

            <div
              v-if="activeTabHash === '#list-redeem-code-belonged'"
              class="p-3"
            >
              <BelongedRedeemCode
                :showFilter="false"
                :excludeFields="['customer']"
                :upperCustomer="customer"
              />
            </div>

            <div v-if="activeTabHash === '#list-orders'" class="p-3">
              <keep-alive>
                <Order
                    :showFilter="false"
                    :excludeFields="['customer_name']"
                    :upperCustomerId="$route.params.customerID"
                    :with-related-orders="true"
                />
              </keep-alive>
            </div>

            <div v-if="activeTabHash === '#list-branches'" class="p-3">
              <BranchList
                :showFilter="false"
                :includeFields="[
                  'created_at',
                  'gift_name',
                  'gift_data',
                  'batch_total_points',
                ]"
                :upperMerchantId="customer.merchant.id"
                :upperCustomerId="$route.params.customerID"
              />
            </div>

            <div v-if="activeTabHash === '#level-history'" class="p-3">
              <b-overlay :show="levelHistoryLoading" rounded="sm">
                <!-- 等級變更紀錄 (Logs) -->
                <div class="mb-4">
                  <h5 class="mb-3">等級變更紀錄</h5>
                  <b-table
                    v-if="levelLogs.length > 0"
                    :items="levelLogs"
                    :fields="levelLogFields"
                    striped
                    hover
                    small
                    responsive
                  >
                    <template #cell(level_name)="data">
                      <b-badge variant="primary">{{ data.value || '-' }}</b-badge>
                    </template>
                    <template #cell(period)="data">
                      {{ data.item.start_at || '-' }} ~ {{ data.item.end_at || '無期限' }}
                    </template>
                  </b-table>
                  <div v-else class="text-muted text-center py-3">
                    尚無等級變更紀錄
                  </div>
                </div>

                <!-- 計算紀錄 (Calculations) -->
                <div>
                  <h5 class="mb-3">等級計算紀錄</h5>
                  <b-table
                    v-if="levelCalculations.length > 0"
                    :items="levelCalculations"
                    :fields="levelCalculationFields"
                    striped
                    hover
                    small
                    responsive
                  >
                    <template #cell(calculation_type_name)="data">
                      <b-badge :variant="getCalculationTypeVariant(data.item.calculation_type)">
                        {{ data.value }}
                      </b-badge>
                    </template>
                    <template #cell(level_change)="data">
                      {{ data.item.before_level_name || '-' }}
                      <i class="mdi mdi-arrow-right mx-1"></i>
                      {{ data.item.after_level_name || '-' }}
                    </template>
                    <template #cell(action_taken_name)="data">
                      <b-badge :variant="getActionTakenVariant(data.item.action_taken)">
                        {{ data.value }}
                      </b-badge>
                    </template>
                    <template #cell(calculated_amount)="data">
                      {{ data.value ? data.value.toLocaleString() : '-' }}
                    </template>
                    <template #cell(memo)="data">
                      <b-button
                        v-if="data.value"
                        v-b-modal.modal-level-memo
                        variant="link"
                        size="sm"
                        class="p-0"
                        @click="selectedMemo = data.value"
                      >
                        查看詳情
                      </b-button>
                      <span v-else>-</span>
                    </template>
                  </b-table>
                  <div v-else class="text-muted text-center py-3">
                    尚無等級計算紀錄
                  </div>

                  <!-- 分頁 -->
                  <div v-if="levelCalculationsMeta.last_page > 1" class="d-flex justify-content-center mt-3">
                    <b-pagination
                      v-model="levelCalculationsPage"
                      :total-rows="levelCalculationsMeta.total"
                      :per-page="levelCalculationsMeta.per_page"
                      @change="handleLevelCalculationsPageChange"
                    ></b-pagination>
                  </div>
                </div>
              </b-overlay>
            </div>
          </div>
        </b-overlay>
      </b-card>
      <b-modal id="modal-full-view" :title="logTitle">
        <JsonEditor
          height="400px"
          v-model="logForFullView"
        />
        <template #modal-footer="{ cancel }">
          <b-button
            variant="outline-danger"
            size="sm"
            class="float-right"
            @click="cancel()"
          >
            關閉
          </b-button>
        </template>
      </b-modal>
      <b-modal id="modal-level-memo" title="等級計算詳情" size="lg">
        <pre class="level-memo-content">{{ selectedMemo }}</pre>
        <template #modal-footer="{ cancel }">
          <b-button
            variant="outline-secondary"
            size="sm"
            class="float-right"
            @click="cancel()"
          >
            關閉
          </b-button>
        </template>
      </b-modal>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import format from "date-fns/format";
import customerApi from "@/apis/customer";
import PermissionChecker from "@/utils/PermissionChecker";
import * as consts from "@/consts";
import _ from "lodash";
import { isValidJsonArray, transformJsonToString } from "@/utils/jsonHelper";
import CustomerStaffList from "./CustomerStaffList.vue";
import CustomerListByUserID from "./CustomerListByUserID.vue";
import CustomerCard from "@/components/Dashboard/Customer/CustomerCard.vue";
import PointLog from "@/components/Dashboard/PointLog/PointLog.vue";
import RedeemLog from "@/components/Dashboard/PointLog/RedeemLog.vue";
import BelongedRedeemCode from "@/components/Dashboard/RedeemCodeBundle/BelongedRedeemCode.vue";
import Order from "@/components/Dashboard/Order/Order.vue";
import BranchList from "@/components/Dashboard/Branch/BranchList.vue";
import "bootstrap-vue/dist/bootstrap-vue.css";
import merchantApi from "@/apis/merchant";
import moment from 'moment'
import JsonEditor from "@/components/Dashboard/JsonEditor.vue";
import tagsMixin from "@/mixins/Dashboard/tags";
import BreadCrumb from "@/components/Dashboard/BreadCrumb";

export default {
  mixins: [tagsMixin],
  components: {
    JsonEditor,
    CustomerStaffList,
    CustomerListByUserID,
    CustomerCard,
    PointLog,
    RedeemLog,
    BelongedRedeemCode,
    Order,
    BranchList,
    BreadCrumb,
  },
  data() {
    return {
      customer: {
        id: this.$route.params.customerID,
        profiles: {},
        merchant: {
          type_name: null,
        },
      },
      customers: [],
      showCustomers:false,
      text: "{customers.data}",
      showLoading: false,
      profileMappings: [],
      consts,
      permissionChecker: new PermissionChecker(),
      fields: [],
      activeTabIndex: 0,
      isEditTags: false,
      originalTags: [],
      tags: [],
      merchants: [],
      activeTabHash: "#tag",
      tabs: [],
      initialized: false,
      hasDetailSetting: false,
      logTitle: null,
      logForFullView: null,
      // 等級歷程相關
      levelHistoryLoading: false,
      levelLogs: [],
      levelCalculations: [],
      levelCalculationsMeta: {
        current_page: 1,
        last_page: 1,
        per_page: 10,
        total: 0,
      },
      levelCalculationsPage: 1,
      selectedMemo: '',
      levelLogFields: [
        { key: 'level_name', label: '等級' },
        { key: 'period', label: '有效期間' },
        { key: 'memo', label: '備註' },
        { key: 'created_at', label: '建立時間' },
      ],
      levelCalculationFields: [
        { key: 'created_at', label: '計算時間' },
        { key: 'calculation_type_name', label: '類型' },
        { key: 'level_change', label: '等級變化' },
        { key: 'action_taken_name', label: '結果' },
        { key: 'calculated_amount', label: '計算金額' },
        { key: 'memo', label: '詳情' },
      ],
    };
  },
  computed: {
    ...mapGetters("general", ["organization"]),
    isEdit() {
      return this.$route.name === "CustomerDetailEdit";
    },
    moment () {
      return moment
    },
    showDeleteButton() {
      if (!this.checkPermission([consts.CUSTOMER_DELETE])) {
        return false;
      }

      return true;
    },
    showSoftDeleteButton() {
      if (!this.checkPermission([consts.CUSTOMER_SOFT_DELETE])) {
        return false;
      }

      return true;
    },
  },
  created() {
    this.loadInitialData();
  },
  methods: {
    isValidJsonArray,
    transformJsonToString,
    async loadInitialData() {
      await Promise.all([
        this.getMerchants(),
        this.getCustomer(),
        this.getSameCustomerList(),
      ]);
      await this.calculateTabs();
      this.setActiveTab();
      this.initialized = true;
    },
    calculateTabs() {
      const hasDetailPermission = !!this.fields;
      const hasStaffBindListPermission = this.checkPermission([
        consts.CUSTOMER_STAFF_VIEW,
      ]);
      //const isMutilMerchants = this.merchants.length > 1;
      const hasPointLogPermission = this.checkPermission([
        consts.POINT_LIST_VIEW,
      ]);
      const hasRedeemLogPermission = this.checkPermission([
        consts.REDEEM_LIST_VIEW,
      ]);
      const hasRedeemCodeUsedListPermission = this.checkPermission([
        consts.REDEEM_CODE_USED_LIST_VIEW,
      ]);
      const hasOrderListPermission = this.checkPermission([
        consts.ORDER_LIST_VIEW,
      ]);
      const hasBranchListPermission = this.checkPermission([
        consts.CUSTOMER_BRANCH_LIST_VIEW,
      ]);
      const hasLevelHistoryPermission = this.checkPermission([
        consts.CUSTOMER_LEVEL_LIST,
      ]);

      let tabs = [
        { title: "標籤", href: "#tag" },
        { title: "基本資料", href: "#basic" },
      ];

      if (hasDetailPermission && this.hasDetailSetting) {
        tabs.push({ title: "詳細資料", href: "#detail" });
      }

      if (hasStaffBindListPermission) {
        tabs.push({ title: "所屬業務", href: "#staff-bind-list" });
      }

      // if (isMutilMerchants) {
      //   tabs.push({ title: "來源通路", href: "#list-by-user-id" });
      // }

      if (hasPointLogPermission) {
        tabs.push({ title: "點數歷程", href: "#list-point-logs" });
      }

      if (hasRedeemLogPermission) {
        tabs.push({ title: "贈品紀錄", href: "#list-redeem-logs" });
      }

      if (hasRedeemCodeUsedListPermission) {
        tabs.push({ title: "優惠券", href: "#list-redeem-code-belonged" });
      }

      if (hasOrderListPermission) {
        tabs.push({ title: "訂單紀錄", href: "#list-orders" });
      }

      if (hasBranchListPermission) {
        tabs.push({ title: "綁定分店", href: "#list-branches" });
      }

      if (hasLevelHistoryPermission) {
        tabs.push({ title: "會員等級紀錄", href: "#level-history" });
      }

      this.tabs = tabs;
    },
    setActiveTab() {
      this.activeTabHash = this.$route.hash || "#tag";
      this.activeTabIndex = this.tabs.findIndex(
        (tab) => tab.href === this.activeTabHash
      );
      // 如果直接導航到等級歷程 tab，載入資料
      if (this.activeTabHash === '#level-history') {
        this.fetchLevelHistory();
      }
    },
    async getMerchants() {
      const { data } = await merchantApi.list();
      this.merchants = data.data;
    },
    async getCustomer() {
      try {
        this.showLoading = true;
        const { data } = await customerApi.getCustomer(
          this.$route.params.customerID
        );
        this.customer = {
          ...data,
          birthday:
            data.birthday && format(new Date(data.birthday), "yyyy-MM-dd"),
          join_datetime:
            data.join_datetime &&
            format(new Date(data.join_datetime), "yyyy-MM-dd HH:mm"),
          leave_datetime:
            data.leave_datetime &&
            format(new Date(data.leave_datetime), "yyyy-MM-dd HH:mm"),
          created_at: format(new Date(data.created_at), "yyyy-MM-dd HH:mm"),
          updated_at: format(new Date(data.updated_at), "yyyy-MM-dd HH:mm"),
          phone_verified_at:
            data.phone_verified_at &&
            format(new Date(data.phone_verified_at), "yyyy-MM-dd HH:mm"),
          email_verified_at:
            data.email_verified_at &&
            format(new Date(data.email_verified_at), "yyyy-MM-dd HH:mm"),
          registered_at:
            data.registered_at &&
            format(new Date(data.registered_at), "yyyy-MM-dd HH:mm"),
          accept_term_at:
            data.accept_term_at &&
            format(new Date(data.accept_term_at), "yyyy-MM-dd HH:mm"),
        };
        // 處理是checkbox類別的 內容要還原回json
        Object.keys(this.customer.profiles).forEach((key) => {
          const value = this.customer.profiles[key];
          // 在這裡處理屬性和值
          if (this.isValidJsonArray(value)) {
            this.customer.profiles[key] = this.transformJsonToString(
              JSON.parse(value)
            );
          }
        });
        this.profileMappings = data.meta.profile_mappings;
        this.text = JSON.stringify(data.data);

        let fields = data.meta.module_config?.member_fields ?? [];
        this.hasDetailSetting = fields.length;
        this.fields = _.sortBy(fields, "order");
        Object.keys(this.fields).forEach((key) => {
          this.fields[key]["matched_key"] = this.fields[key][
            "matched_key"
          ].replace(/extra./g, "");
        });

        this.setTags(this.customer.tags);
        this.showLoading = false;
      } catch (e) {
        console.log(e);
      }
    },
    setTags(tags) {
      this.originalTags = tags.map(tag => tag.name)
      this.tags = tags.map(tag => tag.name)
        .sort((a, b) => a.localeCompare(b));
    },
    async getSameCustomerList() {
      try {
        const { data } = await customerApi.getSameUserCustomers(
          this.$route.params.customerID
        );
        this.customers = data.data.filter(
          (x) => x.id != this.$route.params.customerID
        );
        this.customers.forEach((customer) => {
          if (!customer.merchant_type_name) {
            customer.merchant_type_name = {};
          }
        });
      } catch (e) {
        console.log(e);
      }
    },
    handleCancel() {
      this.$router.push({ name: "CustomerList" });
    },
    checkPermission(permissions) {
      return this.permissionChecker.check(permissions);
    },
    handleTab(tabIndex) {
      if (!this.initialized) {
        return;
      }
      const newHash = this.tabs[tabIndex]?.href;
      const currentPath = this.$route.path;

      this.$router
        .replace({
          path: currentPath,
          hash: newHash,
          query: {},
        })
        .then(() => {
          this.activeTabHash = newHash;
          // 當切換到等級歷程 tab 時，載入資料
          if (newHash === '#level-history' && this.levelCalculations.length === 0) {
            this.fetchLevelHistory();
          }
        })
        .catch((err) => {
          if (err.name !== "NavigationDuplicated") {
            console.error(err);
          }
        });
    },
    handleCancelTags() {
      this.tags = this.customer.tags.map((tag) => {
        return tag.name;
      }).sort((a, b) => a.localeCompare(b));
      this.isEditTags = false;
    },
    async handleSaveTags() {
      let payload = {
        add_tags: this.tags.filter((tag) => !this.originalTags.includes(tag)),
        remove_tags: this.originalTags.filter((tag) => !this.tags.includes(tag)),
      };
      try {
        this.showLoading = true
        await customerApi.setCustomerTags(this.customer.id, payload);
      } catch (e) {
        console.log(e)
      } finally {
        this.showLoading = false
      }
      this.fetchCustomerTags(this.customer.id);
      this.isEditTags = false;
    },
    async fetchCustomerTags(customerId) {
      const { data } = await customerApi.getCustomerTags(customerId);
      this.setTags(data.data)
      this.customer.tags = data.data.map((t) => {
        return { name: t.name, id: t.id  };
      })
    },
    async fetchLevelHistory(page = 1) {
      try {
        this.levelHistoryLoading = true;
        const { data } = await customerApi.getLevelHistory(
          this.$route.params.customerID,
          { page, per_page: 10 }
        );
        // logs 直接是陣列，calculations 有 data 和 meta
        this.levelLogs = data.logs || [];
        this.levelCalculations = data.calculations?.data || [];
        if (data.calculations?.meta) {
          this.levelCalculationsMeta = data.calculations.meta;
        }
      } catch (e) {
        console.error('fetchLevelHistory error:', e);
      } finally {
        this.levelHistoryLoading = false;
      }
    },
    handleLevelCalculationsPageChange(page) {
      this.fetchLevelHistory(page);
    },
    getCalculationTypeVariant(type) {
      const variants = {
        direct: 'success',
        upgrade: 'info',
        keep: 'warning',
      };
      return variants[type] || 'secondary';
    },
    getActionTakenVariant(action) {
      const variants = {
        upgraded: 'success',
        downgraded: 'danger',
        kept: 'warning',
        no_action: 'secondary',
      };
      return variants[action] || 'secondary';
    },
  },
};
</script>

<style lang="scss" scoped>
.text-xl {
  font-size: 1.25rem; /* 20px */
  line-height: 1.75rem; /* 28px */
}
.text-sm {
  font-size: 0.875rem; /* 14px */
  line-height: 1.25rem; /* 20px */
}
.wrapper{
  text-wrap:wrap;
}
.level-memo-content {
  white-space: pre-wrap;
  word-wrap: break-word;
  background-color: #f8f9fa;
  padding: 1rem;
  border-radius: 0.25rem;
  font-size: 0.875rem;
  line-height: 1.5;
  max-height: 400px;
  overflow-y: auto;
}
</style>
